import { render, staticRenderFns } from "./UnmatchedStudentsDialog.vue?vue&type=template&id=3852b2ce&scoped=true"
import script from "./UnmatchedStudentsDialog.vue?vue&type=script&lang=js"
export * from "./UnmatchedStudentsDialog.vue?vue&type=script&lang=js"
import style0 from "./UnmatchedStudentsDialog.vue?vue&type=style&index=0&id=3852b2ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3852b2ce",
  null
  
)

export default component.exports